import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { PrismicRichText, PrismicLink } from '@prismicio/react'
import { useMergePrismicPreviewData } from 'gatsby-plugin-prismic-previews'
import { GatsbyImage } from 'gatsby-plugin-image'

// Components
import Social from './social'
import Newsletter from './newsletter'
// import Logo from './svg/logo'
// import LogoIcon from './svg/logoIcon'
import Phone from './svg/phone'
import Email from './svg/email'
import MapPin from './svg/mapPin'

const Footer = () => {
  const staticData = useStaticQuery(graphql`
    {
      prismicNavigation(lang: { eq: "en-gb" }) {
        ...PrismicNavigationFragment
      }
      prismicConfig(lang: { eq: "en-gb" }) {
        ...PrismicConfigFragment
      }
    }
  `)
  const data = useMergePrismicPreviewData(staticData)
  const footerData = data.prismicNavigation.data
  const config = data.prismicConfig.data

  return (
    <footer role='contentinfo' className='mt-auto bg-gradient-to-r from-brand-blue-dark to-brand-blue-dark border-t-4 border-b-8 border-brand-orange text-white'>
      <div className='mx-auto grid max-w-screen-xl grid-cols-2 gap-12 px-6 py-12 lg:gap-20 xl:grid-cols-6'>
        <div className='col-span-2 flex flex-col gap-4'>
          <Newsletter title={config.mailchimp_title} text={config.mailchimp_text} />
          <a
            aria-label={`call phone number ${config.company_phone}`}
            className='hover:lg:underline decoration-brand-orange underline-offset-8 flex items-center gap-2'
            href={`tel:+44${config.company_phone.replace(' ', '')}`}>
            <Phone className='w-5 h-5 text-brand-orange flex-shrink-0' />
            {config.company_phone}
          </a>
          <div className='flex items-center gap-2'>
            <Email className='w-5 h-5 text-brand-orange flex-shrink-0' />
            {config.company_email}
          </div>
          <div className='flex items-start gap-2'>
            <MapPin className='w-5 h-5 text-brand-orange flex-shrink-0' />
            <PrismicRichText field={config.company_address.richText} />
          </div>
        </div>
        {/* <div className='col-span-2 row-start-2 flex flex-col gap-6 sm:col-span-1 sm:max-w-md xl:col-span-2 xl:row-start-auto'>
          <Link to='/' className='flex items-center gap-2'>
            <GatsbyImage className='w-1/2' image={config.company_logo.gatsbyImageData} alt={config.company_display_name || ''} />
          </Link>
          <div className='lg:space-y-2'>
            <PrismicRichText field={config.company_address.richText} />
            <a aria-label={`call phone number ${config.company_phone}`} className='hover:underline flex items-center' href={`tel:+44${config.company_phone.replace(' ', '')}`}>
              <Phone className='mr-2 h-5 w-5' />
              {config.company_phone}
            </a>
          </div>
          <ul className='flex gap-2'>
            <li className='relative z-10 flex-1 md:flex-none'>
              <a href='../auctions/#!/login' className='button button-primary block w-full text-center hover:border-white md:w-auto'>
                Log In
              </a>
            </li>
            <li className='relative z-10 flex-1 md:flex-none'>
              <a href='../auctions/#!/account' className='button button-default block w-full text-center hover:border-white md:w-auto'>
                Register
              </a>
            </li>
          </ul>
        </div> */}
        {footerData.body.map((footer, index) => {
          return (
            <div className='' key={`footer-${index}`}>
              <div className='mb-6 font-bold text-xl border-b pb-2'>{footer.primary.title}</div>
              <ul className='flex flex-col gap-2'>
                {footer.items.map((footerItem, index) => {
                  return (
                    <li className='my-2' key={`footerItem-${index}`}>
                      <PrismicLink className='py-2 hover:lg:underline decoration-brand-orange underline-offset-8' field={footerItem.link}>
                        {footerItem.link_label}
                      </PrismicLink>
                    </li>
                  )
                })}
              </ul>
            </div>
          )
        })}
        <div className='col-span-2'>
          <GatsbyImage className='w-1/2 mb-2' image={config.company_logo.gatsbyImageData} alt={config.company_display_name || ''} />
          <p>Manufactuing machinery and machine tool auctioneers with over 60 years of experice on our team. Trusted by thousands</p>
          <Social className='mt-4 flex justify-between gap-3 md:order-2 text-brand-orange' />
        </div>
      </div>

      <div className='max-w-screen-xl mx-auto text-right py-4 px-6 text-sm'>
        Site by{' '}
        <a href='https://www.thejuniperstudio.com/' className='hover:underline' rel='noopener'>
          Juniper
        </a>{' '}
        <span className='text-brand-orange'>&copy;</span> <span>{new Date().getFullYear()}</span>
      </div>
    </footer>
  )
}

export default Footer
